module.exports = __webpack_public_path__ + "img/pop-result-encouragement.f71481ea.svg";